import React from 'react';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonLabel,
  IonImg
} from '@ionic/react';
import { connect } from 'react-redux'
import './Home.css';

import IndexActions from '../actions/index';

class Home extends React.Component {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
            <IonTitle>Inicio</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <h2 className="ion-text-center">Bienvenidos a nuestra plataforma de</h2>
          <h1 className="ion-text-center"><IonLabel color="medium">GESTIÓN ACADÉMICA Y EDUCACIÓN VIRTUAL</IonLabel></h1>
          <h2 className="ion-text-center"><IonLabel color="medium">ENFOQUE, COMPROMISO, INTEGRIDAD.</IonLabel></h2>
          <IonCard>
            <IonImg src="assets/img/home1.jpg"/>
            <IonCardHeader>
              <IonCardTitle>Disponibilidad</IonCardTitle>
            </IonCardHeader>

            <IonCardContent>
              Accede a la planificación o calendarización de actividades del proceso de enseñanza-aprendizaje de tus hijos.
            </IonCardContent>
          </IonCard>

          <IonCard>
            <IonImg src="assets/img/home2.jpg"/>
            <IonCardHeader>
              <IonCardTitle>Colaborativo</IonCardTitle>
            </IonCardHeader>

            <IonCardContent>
              Acceso facil y rápido a las Tareas programadas, Guias de estudios online para un acompañamiento más efectivo en la resolución y envios de tareas.
            </IonCardContent>
          </IonCard>

          <IonCard>
            <IonImg src="assets/img/home3.jpg"/>
            <IonCardHeader>
              <IonCardTitle>Recursos</IonCardTitle>
            </IonCardHeader>

            <IonCardContent>
              Accede a todos los recursos múltimedia, certificados de notas,materiales de estudios publicados o compartidos por los docentes.
            </IonCardContent>
          </IonCard>

          <IonCard>
            <IonImg src="assets/img/home4.jpg"/>
            <IonCardHeader>
              <IonCardTitle>Comunicación</IonCardTitle>
            </IonCardHeader>

            <IonCardContent>
              Comunicación permanente y segura entre padres de familia, personal docente, estudiantes y personal administrativo.
            </IonCardContent>
          </IonCard>

        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getMe: () => dispatch(IndexActions.getMe())
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
